<div class="lp-favorite-products">
  <lp-favorite-products-header
    [title]="'components.loyaltyLpFavoriteProducts.labels.favoriteProducts' | translate"
  ></lp-favorite-products-header>

  <tui-scrollbar>
    <app-loader-wrapper [loading]="loading">
      <ng-container *ngIf="products">
        <lp-no-data-found
          *ngIf="products && !products.length"
          [title]="'components.lpFavoriteProducts.labels.noData' | translate"
          [hideIcon]="true"
          [hideSubtitle]="true"
        ></lp-no-data-found>
      </ng-container>

      <div class="lp-favorite-products__products">
        <div class="lp-favorite-products__products_wrapper">
          <ng-container *ngIf="products">
            <lp-product-card
              *ngFor="let product of products"
              [product]="product"
              [showIsFavorite]="true"
            ></lp-product-card>
          </ng-container>
        </div>
      </div>
    </app-loader-wrapper>
  </tui-scrollbar>
</div>
